import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OnboardingService } from '../../../onboarding.service';

@Component({
  selector: 'app-partner-account-details',
  templateUrl: './partner-account-details.component.html',
  styleUrl: './partner-account-details.component.less',
})
export class PartnerAccountDetailsComponent implements OnInit {

  @Input() sponsorOnboardingCMSData: any;
  getGenericLabels: any;
  @Input() partnerAccDetails: any;
  @Output() partnerAccountDataValueChange = new EventEmitter<any>();
  salutationTypeList: any = [];
  commChannelList: any = [];
  newIconUrl: any = 'assets/images/icons/eye_open.png';
  confirmIconUrl: any = 'assets/images/icons/eye_open.png';
  inputConfirmType: any = 'password';
  inputNewType: any = 'password';
  showPassNotMatchError: boolean = true;
  passNotMatchMsg: any = '';
  focusBorderToolTip: boolean = true;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  isValidEmail: boolean = false;
  validEmailMsg: any = '';
  characterlengthcase: boolean = false;
  lowercase: boolean = false;
  uppercase: boolean = false;
  numbercase: boolean = false;
  specialcase: boolean = false;
  showPasswordRulesToolTip: boolean = false;
  lowercaseRegex = /[a-z]/;
  uppercaseRegex = /[A-Z]/;
  numberRegex = /[0-9]/;
  specialCharRegex = /[^a-zA-Z0-9]/;

  constructor(
    private onboardingService: OnboardingService
  ) {}

  ngOnInit(): void {
    this.getGenericLabels = JSON.parse(localStorage.getItem('genericLabels') || '{}');
    this.getSalutationList();
    this.getCommunicationCategory();
  }

  getCommunicationCategory() {
    this.onboardingService.getCommunicationCategory().subscribe({
      next: (res: any) => {
        res.forEach((element: any) => {
          let option = { key: element.code, value: element.name };
          this.commChannelList.push(option);
        });
      },
      error: (error: any) => {
        // this.errorMessage = this.offersService.generateBlindError(error);
      },
    });
  }

  getSalutationList() {
    this.onboardingService.getSalutationList().subscribe({
      next: (res: any) => {
        res.forEach((element: any) => {
          let option = { key: element.code, value: element.name };
          this.salutationTypeList.push(option);
        });
      },
      error: (error: any) => {
        // this.errorMessage = this.offersService.generateBlindError(error);
      },
    });
  }

  valueChange(event: any, key: string) {
    this.showPasswordRulesToolTip = false;
    switch (key) {
      case 'title':
        this.partnerAccDetails.title = event;
        break;
      case 'communicationChannel':
        this.partnerAccDetails.communicationChannel = event;
    }

    this.partnerAccountDataValueChange.emit(this.partnerAccDetails);
  }

  partnerAccValueChange(event: any, key: string) {
    this.showPasswordRulesToolTip = false;
    switch (key) {
      case 'firstName':
        this.partnerAccDetails.firstName = event;
        break;
      case 'lastName':
        this.partnerAccDetails.lastName = event;
      break;
      case 'email':
        this.isValidEmail = true;
        this.validEmailMsg = '';
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        this.partnerAccDetails.email = event;
        if (!emailPattern.test(this.partnerAccDetails.email)) {
          this.isValidEmail = false;
          this.validEmailMsg = this.getGenericLabels.EnterValidEmail;
        } else {
          this.isValidEmail = true;
        }
      break;
      case 'phone':
        this.partnerAccDetails.phone = event;
      break;
      case 'password':
        this.showPasswordRulesToolTip = true;
        this.showPassNotMatchError = true;
        this.passNotMatchMsg = '';
        this.focusBorderToolTip = true;
        this.partnerAccDetails.password = event;
        
        if((this.partnerAccDetails.confirmPassword !== this.partnerAccDetails.password) && (this.partnerAccDetails.password != '') ) {
          this.focusBorderToolTip = false;
          this.showPassNotMatchError = false;
          this.passNotMatchMsg = this.getGenericLabels?.PasswordNotMatch;
        }

        this.characterlengthcase = this.partnerAccDetails.password.length >= 12 && this.partnerAccDetails.password.length <= 64;
        this.lowercase = this.lowercaseRegex.test(this.partnerAccDetails.password);
        this.uppercase = this.uppercaseRegex.test(this.partnerAccDetails.password);
        this.numbercase = this.numberRegex.test(this.partnerAccDetails.password);
        this.specialcase = this.specialCharRegex.test(this.partnerAccDetails.password);

        if (this.characterlengthcase && this.lowercase && this.uppercase && this.numbercase && this.specialcase) {
          this.showPasswordRulesToolTip = false; // Hide tooltip if all criteria are satisfied
        } else {
          this.showPasswordRulesToolTip = true; // Show tooltip if criteria are not met
        }
      break;
      case 'confirmPassword':
        this.showPassNotMatchError = true;
        this.passNotMatchMsg = '';
        this.focusBorderToolTip = true;
        this.partnerAccDetails.confirmPassword = event;
        if((this.partnerAccDetails.confirmPassword !== this.partnerAccDetails.password) && (this.partnerAccDetails.confirmPassword != '') ) {
          this.focusBorderToolTip = false;
          this.showPassNotMatchError = false;
          this.passNotMatchMsg = this.getGenericLabels?.PasswordNotMatch;
        }
    }
    this.partnerAccountDataValueChange.emit(this.partnerAccDetails);
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
    this.inputNewType = this.showNewPassword ? 'text': 'password';
    this.newIconUrl = this.showNewPassword ? 'assets/images/icons/eye_slash_icon.png': 'assets/images/icons/eye_open.png';
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
    this.inputConfirmType = this.showConfirmPassword ? 'text': 'password';
    this.confirmIconUrl = this.showConfirmPassword ? 'assets/images/icons/eye_slash_icon.png': 'assets/images/icons/eye_open.png';
  }

}
